/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------


==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
  getStudent (state) {
    return state.student
  },
  getDeletedUser (state) {
    return state.deletedUser
  },
  getRegisterUserEmail (state) {
    return state.emailRegisteredUser
  },
  getNewsletterJson (state) {
    return state.newsletter_json
  },
  getCompleteResizeImg (state) {
    return state.complete_resize_img
  },
  getStartResizeImg (state) {
    return state.start_resize_img
  },
  getBuilderMenu (state) {
    return state.builder_menu
  },
  getTopbarMessageCounter (state) {
    return state.topbarMessageCounter
  },
  getAppCurrentLocation (state) {
    return state.currentLocation

  },
  getAppCurrentLocationDropdown (state) {
    return state.currentLocationDropdown

  },
  getActitvityProgramDropdown (state) {
    return state.activitiesAppProgramDropdown

  },
  getAppActivityRoom (state) {
    return state.currentAppActivityRoom
  },
  getStudentAccountDetails (state) {
    return state.currentStudentAccountDetails
  },
  getAgencyAccountDetails (state) {
    return state.currentAgencyAccountDetails
  },
  getAgencyStudents (state) {
    return state.currentAgencyStudents
  },
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl'
    else if (state.windowWidth >= 992) return 'lg'
    else if (state.windowWidth >= 768) return 'md'
    else if (state.windowWidth >= 576) return 'sm'
    else return 'xs'
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  }
}

export default getters
